export default {
  path: '/complaintDetail',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'complaintDetail',
  component: () => import('./index')
};
